import { render } from "./DelivryOrdersList.vue?vue&type=template&id=32a53e3e&scoped=true"
import script from "./DelivryOrdersList.vue?vue&type=script&lang=js"
export * from "./DelivryOrdersList.vue?vue&type=script&lang=js"

import "./DelivryOrdersList.vue?vue&type=style&index=0&id=32a53e3e&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a53e3e"]])

export default __exports__